import moment from 'moment';
import _ from 'lodash';
import ExpensesProxy from '@/proxies/Cashier/ExpensesProxy';
import { DATETIME_ISO } from '../../constants/dates';
import { prepareValidationMessages } from '../../utils';

export default {
  data() {
    return {
      errorsExpenseDialog: null,
    };
  },
  methods: {
    onActionExpenseDialog(item) {
      this.errorsExpenseDialog = {};
      if (_.isObject(item)) {
        let expense = new ExpensesProxy();
        const expenseData = {};
        expenseData.datetime = moment(item.datetime).format(DATETIME_ISO);
        expenseData.recipient = item.recipient;
        expenseData.note = item.note;
        expenseData.sum = item.sum;
        expenseData.type = item.type;
        expenseData.confirmation = item.confirmation;
        expenseData.expense_category_id = item.expense_category_id;
        expenseData.manager_id = item.manager_id;
        if (item.uuid) {
          expenseData.uuid = item.uuid;
        }
        if (item.uuid) {
          expense = expense.update(item.uuid, expenseData);
        } else {
          expense = expense.create(expenseData);
        }

        expense.then((response) => {
          // this.cachedFullOrders[item.uuid] = response.data.data.expense;
          this.currentEditableItem = response.data.data.expense;
          this.$store.dispatch('page/displaySnackbar', {
            text: `Расход сохранен. ${this.currentEditableItem.uuid}`,
            color: 'teal lighten-3',
            timeout: 20000,
          });
          this.$store.dispatch('page/updateCurrentPageContent');
          this.isShowExpenseDialog = false;
        })
          .catch((response) => {
            let errors = [];
            if (response && response.data && response.data.data) {
              this.errorsExpenseDialog = prepareValidationMessages(response.data.data);
              errors = Object.values(this.errorsExpenseDialog);
            }
            if (errors.length) {
              this.$store.dispatch('page/displaySnackbar', {
                text: `Ошибка. ${errors[0]}`,
                color: 'red darken-3',
                timeout: 20000,
              });
            } else {
              this.$store.dispatch('page/displaySnackbar', {
                text: 'Непредвиденная ошибка. Обратитесь к разработчику',
                color: 'red darken-3',
                timeout: 20000,
              });
              console.error(response);
            }
          })
          .finally(() => {
          });
      }
    },
  },
};
